import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found-page',
    template: `RESOURCE NOT FOUND`,
    styles: [],
    standalone: false
})
export class NotFoundPageComponent {}
